export function formatCompactNumber(value) {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return "0";

  const sign = numeric < 0 ? "-" : "";
  const absolute = Math.abs(numeric);
  const units = [
    [1e9, "B"],
    [1e6, "M"],
    [1e3, "K"],
  ];
  const unit = units.find(([threshold]) => absolute >= threshold);
  if (!unit) return String(Math.round(numeric));

  const [threshold, suffix] = unit;
  const shortened = Number((absolute / threshold).toFixed(1));
  return `${sign}${shortened}\u00A0${suffix}`;
}
